import React from 'react';
import PracticeSetupPage from './PracticeSetupPage';

const IndividualOnboardingPage = () => {
  return <PracticeSetupPage accountType="individual" />;
};

export default IndividualOnboardingPage;
